import React from 'react';
import history from "../../history";
import connection from "../../connection";
import Swal from "sweetalert2";

//Enrollment Pages
import EventSelection from "./1_event_selection";
import NewOrReturningPlayer from "./2_new_or_returning";
import Welcome from "./3_padelbox_onboarding";
import PadelLevel from "./4_padel_level";
import LeagueSelection from "./6_league_selection";
import CategorySelection from "./7_category_selection";
import PlayerOneRegistration from "./8_player_1_registration";
import PlayerTwoRegistration from "./9_player_2_registration";
import ReplicateEnrollments from "./5_replicate_enrollment";
import TermsAndConditions from "./10_availabilities_terms";
import EnrollmentsList from "./0_list";
import EnrollmentDetails from "./details";
import Payment from "./12_payment";
import PaymentSummary from "./14_done";
import TournamentConditions from "./11_terms";

import withReactContent from "sweetalert2-react-content";
import {Route, withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";

const MySwal = withReactContent(Swal);

class Enrollment extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         formData: {},
         notification: {}
      };
   }

   registrationErrorPopUp = (history) => {
      const { t } = this.props;

      MySwal.fire({
         titleText: t("common.error"),
         text: t("registration_page.errors.submission")
      }).then(() => {
         history.push("/");
      });
   };

   registrationDuplicatePopUp = (history) => {
      const { t } = this.props;

      MySwal.fire({
         titleText: t("common.attention"),
         text: t("registration_page.errors.duplicate_registration")
      }).then(() => {
         history.push("/");
      });
   };

   nextPage = nextPage => {
      history.push(nextPage);
   };

   saveData = (data, nextPage) => {
      const {formData} = this.state;

      this.setState({formData: {...formData, ...data}}, () => {
         history.push(nextPage);
      });
   };

   concludeRegistration = (registrationId) => {
      const { t } = this.props;
      const {formData} = this.state;

      if (formData.isLeague && formData.single_enrollment) {
         MySwal.fire({
            showCancelButton: false,
            titleText: t("registration_page.registration_success"),
            text: t("registration_page.registration_single"),
            confirmButtonText: "Ok"
         }).then(async (res) => {
            history.push('/enrollment/list');
         });
      } else {
         let paymentMethod;
         if (formData.isLeague) {
            paymentMethod = formData.league_payment_method === undefined ? formData.league_edition_payment_method : formData.league_payment_method;
         }else {
            paymentMethod = formData.tournament_payment_method
         }

         if (paymentMethod === "Pagamento por DPG") {
            history.push(`/enrollment/${registrationId}/payment`, {isLeague: formData.isLeague});
         } else {
            history.push(`/enrollment/${registrationId}/payment_summary`, {paymentMethod, isLeague: formData.isLeague});
         }
      }
   };

   cleanupRegistrationData = () => {
      const registration = {};
      const {formData} = this.state;

      if (formData.isLeague) {
         registration.league_edition_id = formData.id;
         registration.league_id = formData.league_id;
         registration.league_category_id = formData.league_category_id;
         registration.league_edition_name = formData.name;
         registration.fpp_licence_needed = formData.fpp_licence_needed;
         registration.shirt_needed = formData.shirt_needed;
         registration.welcomepack_needed = formData.welcomepack_needed;
         registration.allow_singles = formData.allow_singles;
         registration.padel_level = formData.padel_level;
         registration.partner = formData.partner_registration;
         registration.info_and_conditions = formData.info_and_conditions;
         registration.welcomepack_location = formData.info_and_conditions.welcomepack_location;
         registration.info_and_conditions.billing_name = formData.info_and_conditions.billing_name.trim();

         registration.user = formData.user_registration;
         registration.user.to_log = "inscrição_liga";

         delete registration.info_and_conditions.welcomepack_location;

         if (formData.partner_registration !== undefined) {
            registration.single_enrollment =
               formData.partner_registration.single_enrollment;
            registration.partner.to_log = "inscrição_liga";
            delete registration.partner.single_enrollment;
            delete registration.partner.offers;
         }

         delete registration.user.offers;
      } else {
         registration.is_league = formData.isLeague
         registration.super_tournament_id = formData.id;
         registration.tournament_id = formData.category_id;
         registration.tournament_name = formData.name;
         registration.fpp_licence_needed = formData.fpp_licence_needed;
         registration.shirt_needed = formData.shirt_needed;
         registration.welcomepack_needed = formData.welcomepack_needed;
         registration.allow_singles = formData.allow_singles;
         registration.padel_level = formData.padel_level;
         registration.partner = formData.partner_registration;
         registration.info_and_conditions = formData.info_and_conditions;
         registration.info_and_conditions.billing_name = formData.info_and_conditions.billing_name.trim();

         registration.user = formData.user_registration;
         registration.user.to_log = "inscrição_torneio";

         if (formData.partner_registration !== undefined) {
            registration.single_enrollment =
               formData.partner_registration.single_enrollment;
            registration.partner.to_log = "inscrição_torneio";
            delete registration.partner.single_enrollment;
            delete registration.partner.offers;
         }
      }

      return registration;
   };


   render() {
      const {formData} = this.state;
      const namespace = this.props.match.url;
      const { t } = this.props;

      return <>
         <Route
            exact
            path={namespace + "/select-event"}
            render={() => {
               return (
                  <EventSelection
                     formData={formData}
                     onSubmit={data => {
                        this.setState(
                           {formData: {...formData, ...data}},
                           () => {
                              if (this.state.formData.isLeague) {
                                 this.nextPage('/enrollment/new_or_returning');
                              } else {
                                 this.nextPage('/enrollment/replicate');
                              }
                           }
                        );
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/new_or_returning"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <NewOrReturningPlayer
                     formData={formData}
                     onSubmit={data => {
                        this.setState(
                           {formData: {...formData, ...data}},
                           () => {
                              if (this.state.formData.is_new) {
                                 this.nextPage('/enrollment/welcome');
                              } else {
                                 this.nextPage('/enrollment/replicate');
                              }
                           }
                        );
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/welcome"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <Welcome
                     formData={formData}
                     onSubmit={() => this.nextPage('/enrollment/padel_level')}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/padel_level"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <PadelLevel
                     formData={formData}
                     onSubmit={data =>
                        this.saveData(data, '/enrollment/leagues')
                     }
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/leagues"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <LeagueSelection
                     formData={formData}
                     onSubmit={data => {
                        if (formData.is_replication) {
                           if (formData.isLeague) {
                              this.saveData(
                                 data,
                                 '/enrollment/player_one_registration'
                              );
                           } else {
                              this.saveData(data, '/enrollment/categories');
                           }
                        } else {
                           this.saveData(data, '/enrollment/categories');
                        }
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/categories"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <CategorySelection
                     formData={formData}
                     onSubmit={data => {
                        this.saveData(
                           data,
                           '/enrollment/player_one_registration'
                        );
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/player_one_registration"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <PlayerOneRegistration
                     formData={formData}
                     onSubmit={data => {
                        const nextPage = data.single_enrollment && !formData.isLeague
                           ? '/enrollment/conditions'
                           : '/enrollment/player_two_registration';

                        this.saveData(data, nextPage);
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/player_two_registration"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <PlayerTwoRegistration
                     formData={formData}
                     onSubmit={data => {
                        if (data.single_enrollment && formData.isLeague) {
                           this.saveData(data, '/enrollment/terms_and_conditions');
                        } else if (formData.isLeague) {
                           this.saveData(data, '/enrollment/terms_and_conditions');
                        } else {
                           this.saveData(data, '/enrollment/conditions');
                        }
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/replicate"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <ReplicateEnrollments
                     formData={formData}
                     onSubmit={data => {
                        this.setState(
                           {formData: {...formData, ...data}},
                           () => {
                              if (!this.state.formData.is_replication) {
                                 if (this.state.formData.isLeague) {
                                    this.nextPage('/enrollment/leagues');
                                 } else {
                                    this.nextPage('/enrollment/categories');
                                 }
                              } else if (this.state.formData.isLeague) {
                                 this.nextPage('/enrollment/leagues');
                              } else {
                                 this.nextPage('/enrollment/categories');
                              }
                           }
                        );
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/terms_and_conditions"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <TermsAndConditions
                     formData={formData}
                     onSubmit={data => {
                        this.setState(
                           {formData: {...formData, ...data}},
                           async () => {
                              const registration = this.cleanupRegistrationData();

                              try {
                                 const response = await connection.post(
                                    'v1/registrations.json',
                                    registration
                                 );

                                 if (response.error) {
                                    if (response.error.includes('Este utilizador já tem uma inscrição nesta liga nesta categoria') || response.error.includes('Team já existe')) {
                                       this.registrationDuplicatePopUp(this.props.history);
                                    } else {
                                       this.registrationErrorPopUp(this.props.history);
                                    }
                                 } else {
                                    this.concludeRegistration(response.id);
                                 }
                              } catch (error) {
                                 this.registrationErrorPopUp(this.props.history);
                              }
                           }
                        );
                     }}
                  />
               );
            }}
         />
         <Route
            exact
            path={namespace + "/conditions"}
            render={() => {
               if (Object.keys(formData).length === 0) {
                  this.nextPage('/enrollment/select-event');
               }

               return (
                  <TournamentConditions
                     formData={formData}
                     onSubmit={data => {
                        this.setState(
                           {formData: {...formData, ...data}},
                           async () => {
                              const registration = this.cleanupRegistrationData();

                              try {
                                 const response = await connection.post(
                                    'v1/tournament_registrations.json',
                                    registration
                                 );

                                 if (response.error) {
                                    if (response.error.includes('Team já existe') || response.error.includes('Este utilizador já tem uma inscrição neste torneio nesta categoria')) {
                                       this.registrationDuplicatePopUp(this.props.history);
                                    } else {
                                       this.registrationErrorPopUp(this.props.history);
                                    }
                                 } else {
                                    this.concludeRegistration(response.id);
                                 }
                              } catch (error) {
                                 this.registrationErrorPopUp(this.props.history);
                              }
                           }
                        );
                     }}
                  />
               );
            }}
         />
         <Route exact path={namespace + "/:registrationId/payment"} render={(props) => <Payment {...props}/>}/>

         <Route exact path={namespace + "/:registrationId/payment_summary"} render={(props) => <PaymentSummary {...props}/>}/>

         <Route exact path={namespace + "/list"} component={EnrollmentsList}/>

         <Route exact path={namespace + "/details"} render={(props) => <EnrollmentDetails {...props}/>}/>
      </>
   }
}

export default withTranslation()(withRouter(Enrollment));
